const AppConfig = {
  'auth_mode'                : ( typeof(process.env.REACT_APP_AUTH_MODE) !== 'undefined' ) ? process.env.REACT_APP_AUTH_MODE : null,
  'auth_provider_url'        : ( typeof(process.env.REACT_APP_AUTH_PROVIDER_URL) !== 'undefined' ) ? process.env.REACT_APP_AUTH_PROVIDER_URL : null,
  'auth_client_id'           : ( typeof(process.env.REACT_APP_AUTH_CLIENT_ID) !== 'undefined' ) ? process.env.REACT_APP_AUTH_CLIENT_ID : null,
  'auth_client_secret'       : ( typeof(process.env.REACT_APP_AUTH_CLIENT_SECRET) !== 'undefined' ) ? process.env.REACT_APP_AUTH_CLIENT_SECRET : null,
  'ptp_core_sluice'          : ( typeof(process.env.REACT_APP_PTP_CORE_SLUICE) !== 'undefined' ) ? process.env.REACT_APP_PTP_CORE_SLUICE : null,
  'ptp_client_sluice'        : ( typeof(process.env.REACT_APP_PTP_CLIENT_SLUICE) !== 'undefined' ) ? process.env.REACT_APP_PTP_CLIENT_SLUICE : null,
  'ptp_api_group_access_key' : ( typeof(process.env.REACT_APP_PTP_API_GROUP_ACCESS_KEY) !== 'undefined' ) ? process.env.REACT_APP_PTP_API_GROUP_ACCESS_KEY : null,
  'ptp_api_group_secret_key' : ( typeof(process.env.REACT_APP_PTP_API_GROUP_SECRET_KEY) !== 'undefined' ) ? process.env.REACT_APP_PTP_API_GROUP_SECRET_KEY : null,
};

export const getConfig = (key) => {
  if (typeof key === "undefined") return AppConfig;
  else if (typeof AppConfig[key] !== "undefined") return AppConfig[key];
  else return null;
};

export const setConfig = (config) => {
  Object.assign(AppConfig, config);
  return AppConfig;
};

export default AppConfig;
